/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Location from './Location/index'
import More from './More/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Locations/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="regular"
 marginRight={dtSpaceXs}
 color={dtColorsNeutral600}
 text="Patient in"
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<More
  viewPath={`${viewPath}/More`}
/>
</div>
</div>
{children}
</React.Fragment>)
}